import { payment } from './role'

export const queries = {
  payment,
}
export default queries
